import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "addComment" }
const _hoisted_2 = { class: "addComment__header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  class: "label-comment",
  for: "comment"
}
const _hoisted_5 = { class: "addComment__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.showModalAddComment)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _ctx.closeModalAndFormData
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('addCommentSensor')), 1),
              _createElementVNode("img", {
                class: "addComment__header-img",
                src: _imports_0,
                alt: "Close Modal",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModalAndFormData && _ctx.closeModalAndFormData(...args)))
              })
            ]),
            _createVNode(_component_FormKit, {
              id: "addComment-form",
              modelValue: _ctx.formData,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData) = $event)),
              type: "form",
              actions: false,
              onSubmit: _ctx.submitHandler
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('comment')), 1),
                _withDirectives(_createElementVNode("textarea", {
                  id: "comment",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.comment) = $event)),
                  class: "input-comment",
                  maxlength: "250"
                }, "        ", 512), [
                  [_vModelText, _ctx.formData.comment]
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "onSubmit"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                variant: "filled",
                title: _ctx.$t('save'),
                onClick: _ctx.addComment
              }, null, 8, ["title", "onClick"]),
              _createVNode(_component_Button, {
                variant: "bordered",
                title: _ctx.$t('cancel'),
                onClick: _ctx.closeModalAndFormData
              }, null, 8, ["title", "onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}